
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gBSqBX7BcWs9bgO2RJcezW7ccAe7GSsEGSfRPSDCJppMMeta } from "/codebuild/output/src17478091/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexr5Ttvz9IYLpMP66ZPXItNMqvRGFUOFl7LyCeVyUYhZoMeta } from "/codebuild/output/src17478091/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchiVFZRki3jQlqX1KOLAo6Olxy1uGeuaPZw8tvOBiCHb0Meta } from "/codebuild/output/src17478091/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexOhuKJFE50WYqBFLoMh30AcHv6Tv5vA0isFh1kItsk9wMeta } from "/codebuild/output/src17478091/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_932alA4VgJB90k_457Rnm4xct3i8Yuybuv3xl6iH0NWqgZIMeta } from "/codebuild/output/src17478091/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexhDqJF5YJwbVVBSj_45zTEblWJYIEk8ZbosTymueJ4upAAMeta } from "/codebuild/output/src17478091/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93GwO0VFhUBjF_yuLsskln8MahouG0e4qISiijw7ckoCoMeta } from "/codebuild/output/src17478091/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexEXVfavuxQihPAz99DYzBzMUZ1O3cO6ApKY6nff8rKTAMeta } from "/codebuild/output/src17478091/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93HhgUW1NbcRbNWimjZXcvadYepYnqCDICONFnFVQmyksMeta } from "/codebuild/output/src17478091/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexWjqYhRZXCi1IDkHqstfSaziG6po5w0xYiT5e2Ju96AMMeta } from "/codebuild/output/src17478091/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexmA4uUnbDjD_45Td8QDkewuOXytrEaxaazyDUp8di1OaggMeta } from "/codebuild/output/src17478091/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src17478091/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src17478091/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src17478091/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src17478091/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src17478091/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexhDqJF5YJwbVVBSj_45zTEblWJYIEk8ZbosTymueJ4upAAMeta || {},
    component: () => import("/codebuild/output/src17478091/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src17478091/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexEXVfavuxQihPAz99DYzBzMUZ1O3cO6ApKY6nff8rKTAMeta || {},
    component: () => import("/codebuild/output/src17478091/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src17478091/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexWjqYhRZXCi1IDkHqstfSaziG6po5w0xYiT5e2Ju96AMMeta || {},
    component: () => import("/codebuild/output/src17478091/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexmA4uUnbDjD_45Td8QDkewuOXytrEaxaazyDUp8di1OaggMeta || {},
    component: () => import("/codebuild/output/src17478091/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]